// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingState_loader__NfahY","loader-wrapper":"LoadingState_loader-wrapper__adIfJ","rotation":"LoadingState_rotation__tCE7Q"};